import { Component, Input } from "@angular/core";

import { TableRow } from "../docs-list/docs-list.component";

@Component({
  selector: "lh-docs-toolbar",
  templateUrl: "./docs-toolbar.component.html",
  styleUrls: ["./docs-toolbar.component.scss"],
})
export class DocsToolbarComponent {
  @Input() rows: TableRow[] = [];
  @Input() documentIds: string[] = [];
}
